export const END_CALL_KEY = 'END_CALL_KEY';
export const GO_MAIN = 'GO_MAIN';
